
export default function TestimonialsSection() {
  const testimonials = [
    {
      id: 1,
      name: '田中 美咲',
      age: '32歳・会社員',
      avatar: 'https://public.readdy.ai/ai/img_res/f0ed1f5eb59235384e1902f5d1e40d21.jpg',
      content: '商品開発に自分の意見が活かされるのが嬉しいです。フィードバックをお送りした後、実際に商品が改良されているのを見ると、参加して良かったと感じます。',
      category: '美容・コスメ'
    },
    {
      id: 2,
      name: '佐藤 健太',
      age: '28歳・エンジニア',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20Japanese%20man%20portrait%20smiling%20confident%20business%20casual%20attire%20clean%20background%20headshot%20style%20corporate%20photography%20friendly%20expression%20natural%20lighting&width=400&height=400&seq=avatar-002&orientation=squarish',
      content: '新しいガジェットを他の人より早く体験できるのが魅力です。しっかりとしたフィードバックをお送りすると、適正な謝礼もいただけて満足しています。',
      category: '家電・ガジェット'
    },
    {
      id: 3,
      name: '山田 由美',
      age: '45歳・主婦',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20middle%20aged%20Japanese%20woman%20portrait%20smiling%20warm%20expression%20casual%20attire%20clean%20background%20headshot%20style%20natural%20lighting%20friendly%20maternal&width=400&height=400&seq=avatar-003&orientation=squarish',
      content: '家族で使える商品を体験させていただいています。子どもたちの反応も含めてフィードバックをお送りすると、メーカーの方に喜んでいただけました。',
      category: '日用品・食品'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            参加者の声
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            商品体験プログラムにご参加いただいた方々からのお声をご紹介します
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial) => (
            <div key={testimonial.id} className="bg-white rounded-2xl shadow-lg p-8 hover:shadow-xl transition-shadow">
              <div className="flex items-center mb-6">
                <img
                  src={testimonial.avatar}
                  alt={testimonial.name}
                  className="w-16 h-16 rounded-full object-cover mr-4"
                />
                <div>
                  <h3 className="font-bold text-gray-900">{testimonial.name}</h3>
                  <p className="text-gray-600 text-sm">{testimonial.age}</p>
                  <span className="inline-block bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded-full mt-1">
                    {testimonial.category}
                  </span>
                </div>
              </div>
              
              <div className="mb-4">
                <div className="flex text-yellow-400 mb-2">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <i key={star} className="ri-star-fill text-lg"></i>
                  ))}
                </div>
                <p className="text-gray-700 leading-relaxed italic">
                  "{testimonial.content}"
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-blue-50 rounded-2xl p-8">
          <div className="text-center">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              <i className="ri-heart-line mr-2 text-red-500"></i>
              参加者満足度
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="text-center">
                <div className="text-4xl font-bold text-blue-600 mb-2">95%</div>
                <p className="text-gray-700">総合満足度</p>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold text-green-600 mb-2">98%</div>
                <p className="text-gray-700">商品体験満足度</p>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold text-purple-600 mb-2">92%</div>
                <p className="text-gray-700">リピート参加率</p>
              </div>
            </div>
            <p className="text-gray-600 text-sm mt-6">
              ※2023年度参加者アンケート結果（回答者数：1,247名）
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
